import type {
  DepositAddressDto,
  DepositCheckDto,
  DepositDto,
  DepositWalletsDto,
} from "types/api/deposits";
import { http, RequestOptions } from "./transport";

// USDT (TRC-20) balance deposits to the user's permanent address
// (docs/USDT_DEPOSITS.md).

// The only network the deposit address supports for now.
export const USDT_NETWORK = "TRC20";

export const deposits = {
  wallets: (): Promise<DepositWalletsDto> => http.get("/deposits/wallets"),
  // Creates the address on the first call and makes the backend scan it
  // more often for an hour — call it every time the deposit screen opens.
  address: (network = USDT_NETWORK): Promise<DepositAddressDto> =>
    http.get("/deposits/address", { params: { network } }),
  // Scans the address now and every minute until `check_until`; 429 with
  // `retry_at` when asked again within a minute.
  check: (network = USDT_NETWORK): Promise<DepositCheckDto> =>
    http.post("/deposits/check", null, { params: { network } }),
  // Credited deposits only, newest first.
  list: (options?: RequestOptions): Promise<DepositDto[]> =>
    http.get("/deposits", options),
};

export type DepositsApi = typeof deposits;
